import { render, staticRenderFns } from "./requestChangeModal.vue?vue&type=template&id=97e79f68&scoped=true&"
import script from "./requestChangeModal.vue?vue&type=script&lang=tsx&"
export * from "./requestChangeModal.vue?vue&type=script&lang=tsx&"
import style0 from "./requestChangeModal.vue?vue&type=style&index=0&id=97e79f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e79f68",
  null
  
)

export default component.exports